import styled from "styled-components";
import Flex from "../../Flex";

/**
 * @internal
 */
export const CircleWrapper = styled.div<{ $size: number }>`
    z-index: 0;
    position: relative;
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
`;

CircleWrapper.displayName = "CircleWrapper";

/**
 * @internal
 */
export const ProgressCircleInsideLabelsWrapper = styled(Flex)`
    z-index: -1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

ProgressCircleInsideLabelsWrapper.displayName = "ProgressCircleInsideLabelsWrapper";

/**
 * @internal
 */
export const ProgressRingSvg = styled.svg<{ $size: number }>`
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
    transform: rotate(-90deg);
    transition: width 150ms ease-in-out, height 150ms ease-in-out;
`;

ProgressRingSvg.displayName = "ProgressRingSvg";

/**
 * @internal
 */
export const ProgressRingCircle = styled.circle<{ $strokeWidth: number }>`
    fill: transparent;
    stroke-linecap: round;
    stroke-width: ${({ $strokeWidth }) => $strokeWidth}px;
    transition: all 150ms ease-in-out;
`;

ProgressRingCircle.displayName = "ProgressRingCircle";
